export const OPERATOR_STATUS_TYPES = {
  ALL: 'all',
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
};

export default OPERATOR_STATUS_TYPES;
